<template>
  <div>
    <el-dialog
    custom-class="acagrid-prompt-page"
    width="900px"
    :title="title"
    :visible.sync="scholarPcVisible"
    :close-on-press-escape="true"
    :close-on-click-modal="true"
    :before-close="closeDialog"
    :lock-scroll="false">
    <el-row type='flex' justify='center'>
      <el-col :span='12'>
        <img class="content-img" :src="imgSrc" alt="">
      </el-col>
    </el-row>
    <el-row type='flex' justify='center'>
      <el-col :span='12'>
        <p class="content-prompt">{{message}}</p>
      </el-col>
    </el-row>
    <el-row type='flex' justify='center'>
      <el-col :span='12'>
        <p class="content-detail-prompt">{{subMessage}}</p>
      </el-col>
    </el-row>
    <el-row type='flex' justify='center'>
      <el-col :span='12'>
        <el-button class="foot-button" type="primary" @click="buttonAction">{{buttonText}}</el-button>
      </el-col>
    </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    scholarPcVisible: Boolean,
    title: String,
    message: String,
    subMessage: String,
    buttonText: String,
    imgSrc: String
  },
  data () {
    return {
    }
  },
  methods: {
    buttonAction () {
      this.$emit('buttonAction')
    },
    closeDialog () {
      this.$emit('closeAcagridDialog')
    }
  }
}
</script>
<style scpoed lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/components/AddDialog/index.vue